export const MAX_TARGET_MOISTURE = 15;